module.exports = __webpack_public_path__ + "media/lan/LanCam-0e2be11c.png";